/**
 * This file contains utility functions for working with arrays, specifically for getting unique values.
 * @param array
 * @param key
 * @returns
 */
export function uniqueArrayByKey<T>(array: T[], key: keyof T): T[] {
	return Array.from(new Map(array.map((item) => [item[key], item])).values());
}

/**
 * This function is used to get a unique array from an array.
 * @param array
 * @returns
 */
export function uniqueArray<T extends string | number>(array: T[]): T[] {
	return Array.from(new Set(array));
}
